import styled from 'styled-components';
import { H3Title } from '~/containers/styles';

export const FilterContainer = styled.div`
  text-align: right;
`;

export const H3TitleExtraMargin = styled(H3Title)`
  margin: 15px 0;
`;

export const EmptyStatePanel = styled.div`
  height: 450px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.05);
`;

export const FilteAndOptionContainer = styled.div`
  margin-bottom: 15px;
`;

export const MaxDataSection = styled.div`
  margin: 15px 0 35px;
`;



// WEBPACK FOOTER //
// ./resources/assets/js/containers/SeismicWave/styles.js